import { Route, Routes } from 'react-router-dom';

import { mapObject } from '@client/toolkit';

import { AgreementListRoute } from './agreement-list/agreement-list.route';
import { AgreementListLayout } from './agreement-list/agreement-list.layout';
import { AgreementReportsRoute } from './agreement-list/agreement-reports.route';
import { AgreementLayout } from './agreement/agreement.layout';
import { AgreementDetailsRoute, AgreementPartiesRoute, AgreementDocumentsRoute, AgreementInvoicingRoute, AgreementAuditTrailRoute } from './agreement/routes';
import { PermissionProtectedRoute } from '../../components/permission-protected-route';
import { PermissionKeys } from '@client/api';

export const AgreementsPaths = {
  AgreementList: '/agreements',
  AgreementReports: '/agreements/reports',
  Agreement: '/agreements/:id',
  AgreementParties: '/agreements/:id/parties',
  AgreementDocuments: '/agreements/:id/documents',
  AgreementInvoicing: '/agreements/:id/invoicing',
  AgreementAuditTrail: '/agreements/:id/audit-trail',
  Order: '/agreements/:id/order/:orderId',
  OrderCreate: '/agreements/:id/order/add',
};

const RouterPaths = mapObject(AgreementsPaths, (val: string) => val.replace(AgreementsPaths.AgreementList, ''));

export const AgreementsRouter = () => (
  <Routes>
    <Route
      element={
        <PermissionProtectedRoute requiredPermission={[PermissionKeys.Tenant.AgreementsList]}>
          <AgreementListLayout />
        </PermissionProtectedRoute>
      }
    >
      <Route index element={<AgreementListRoute />} />
      <Route path="reports" element={<AgreementReportsRoute />} />
    </Route>

    <Route path={RouterPaths.Agreement} element={<AgreementLayout />}>
      <Route index element={<AgreementDetailsRoute />} />
      <Route path="parties" element={<AgreementPartiesRoute />} />
      <Route path="documents" element={<AgreementDocumentsRoute />} />
      <Route path="invoicing" element={<AgreementInvoicingRoute />} />
      <Route path="audit-trail" element={<AgreementAuditTrailRoute />} />
    </Route>
  </Routes>
);
